module.exports = __webpack_public_path__ + "img/hr-level3addon_running_mask.72583058.png";